import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/polyglow-logo.svg";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="notFound">
      <Link to="/">
        <img src={logo} alt="Logo Polyglow" style={{ width: "100%" }} />
      </Link>

      <h1>404</h1>
      <p>Page introuvable</p>

      <button onClick={() => navigate("/themeSelector")}>
        Retour à la sélection du thème
      </button>
    </div>
  );
}